import URIS from 'constants/uris';
import http from 'services/http';

getOneTimeToken.operation = 'NO_OPERATION';
export function getOneTimeToken() {
  return http
    .post(URIS.ONE_TIME_TOKENS, { dummy: 1 })
    .then(({ data: { otpToken: token } }) => token);
}
